<!-- for SEO purposes only -->
<h1 class="hidden">Купи и продай велосипеди, тротинетки и части – лесно и бързо</h1>
<p class="hidden">
  Добре дошли в <strong>na2kolela.bg</strong> – специализираната онлайн платформа за всички любители на двуколесните
  превозни средства! Тук можете да откриете голямо разнообразие от обяви за <strong>велосипеди</strong>,
  <strong>тротинетки</strong>, както и всякакви <strong>части за велосипеди</strong> и <strong>части за
    тротинетки</strong>. Независимо дали търсите своето ново планинско колело, градски велосипед или надеждна
  електрическа тротинетка, вие сте на правилното място.
</p>
<p class="hidden">
  За купувачите предлагаме удобна търсачка и детайлни филтри, с които лесно да намерите точно това, което ви трябва –
  филтрирайте по цена, марка, състояние и местоположение. Разгледайте обявите, сравнете офертите и се свържете директно
  с продавача.
</p>
<p class="hidden">
  Искате да продадете? Създайте своя профил за минути и публикувайте обява напълно безплатно. Достигнете до хиляди
  потенциални купувачи от цялата страна, които търсят точно това, което предлагате.
</p>
<!--  -->
<otw-home-banners-wrapper>
  @if(!isCategoryLoading()){
  <div class="w-full bg-lightGreen min-h-[200px] p-4 px-6 rounded-b-lg">
    <form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <otw-form-field label="Цена от" for="price_min">
        <p-inputnumber inputId="price_min" formControlName="price_min" class="w-full" size="small" class="w-full"
          mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="2" styleClass="w-full" />
      </otw-form-field>
      <otw-form-field label="Цена до" for="price_max">
        <p-inputnumber inputId="price_max" formControlName="price_max" class="w-full" size="small" mode="decimal"
          [minFractionDigits]="0" [maxFractionDigits]="2" styleClass="w-full" />
      </otw-form-field>
      <otw-region-city-selector controlKey="regionCity" layout="horizontal" labelColor="white" inputSize="small"
        classNames="md:col-span-2 gap-4" containerClassNames="gap-4 flex-col md:flex-row"></otw-region-city-selector>

      @if(requiredAttributes().length>0){
      <ng-container formGroupName="attributes">
        @for(attribute of requiredAttributes(); track $index) {
        @let dataType = attribute.data_type;

        @if(dataType === "integer_option" || dataType === "string_option"){
        @let options = dataType === "integer_option" ?
        attribute.integer_option : attribute.string_option;
        <otw-form-field [label]="attribute.name" [for]="attribute.id">
          <!-- <p-select [options]="toOptions(options)" [formControlName]="attribute.id" class="w-full" [showClear]="true"
            size="small" [checkmark]="true" /> -->
          <p-multiselect [options]="toOptions(options)" [formControlName]="attribute.id" dataKey="value"
            optionLabel="label" optionValue="value" styleClass="w-full" size="small" display="chip"
            [showToggleAll]="false" />
        </otw-form-field>
        }@else if (dataType==="string") {
        <otw-form-field [label]="attribute.name" [for]="attribute.id">
          <input pInputText [name]="attribute.id" [formControlName]="attribute.id" class="w-full" pSize="small" />
        </otw-form-field>
        }@else if (dataType === "integer" ) {
        <otw-form-field [label]="attribute.name" [for]="attribute.id">
          <p-inputnumber [name]="attribute.id" [formControlName]="attribute.id" class="w-full" size="small" />
        </otw-form-field>
        } @else {
        <p class="text-red-500">No renderer found</p>
        } }
      </ng-container>
      }

      <otw-form-field label="Състояние" class="md:col-span-2">
        <otw-checkbox-multiselect-form-field formControlName="condition"
          containerClass="!items-start flex-col sm:flex-row" [options]="conditionOptions">
        </otw-checkbox-multiselect-form-field>
      </otw-form-field>
      <div class="md:col-span-2 lg:col-span-4 sm:grid lg:grid-cols-4 gap-4 ">
        <div class="lg:col-start-4 w-full h-full">
          <p-button label="Търси" severity="primary" type="submit" styleClass="!w-full h-[70px] mb-2 !uppercase" />
          <div class="text-center">
            <a [routerLink]="['/search']" [queryParams]="{slug:selectedSlug()}"
              class="text-white hover:underline cursor-pointer"> Още критерии за търсене
              <i class="pi pi-filter-fill"></i> </a>
          </div>
        </div>
      </div>
    </form>
  </div>
  }@else {
  <p-skeleton width="100%" styleClass="min-h-[200px] p-4 px-6 rounded-b-lg" />
  }
  <div class="">
    <otw-listings [listings]="listings()" [isLoading]="isCategoryLoading() || areListingsLoading()"></otw-listings>
  </div>
</otw-home-banners-wrapper>